export default "<div [chart]=\"oxygen\"></div>\n<button type=\"button\" (click)=\"refrash()\" class=\"btn btn-primary\">Refreash</button>"